import cpaFormStyles from './california-privacy-form';

$("#submit-cpa-form").click(function () {
  var firstName = document.getElementById("first-name").value;
  var lastName = document.getElementById("last-name").value;
  var email = document.getElementById("email-address").value;
  var phone = document.getElementById("phone").value;
  if (email == "" && phone == "") {
    var errorMessage = document.getElementById("errorMessage");
    errorMessage.style.display = "block";
  }
  if (email !== "" || phone !== "") {
    var cpaBody = document.getElementById("cpaBody");
    cpaBody.style.display = "none";
    var cpaForm = document.getElementById("cpaForm");
    cpaForm.style.display = "none";
    var thankYou = document.getElementById("thankYou");
    thankYou.style.display = "block";
  }
  var cpaFormArray = { "firstName": firstName, "lastName": lastName, "email": email, "phone": phone }
  $.ajax({
    type: 'POST',
    url: cpfAction,
    dataType: "json",
    data: cpaFormArray
  });
});
